import { LanguageInfo } from "../types";
// Language information including name, code, and flag emoji
export const languages: LanguageInfo[] = [
  { name: "English", code: "en", flag: "🇺🇸" },
  { name: "Français", code: "fr", flag: "🇫🇷" },
];

// Translation keys for all UI elements
const translations: any = {
  en: {
    // Navigation (Add these if not in your NavBar component)
    nav_brand: "FUKKONI", // Added key for brand/logo text
    nav_home: "Home",
    nav_features: "Features",
    nav_pricing: "Pricing",
    nav_about: "About", // Added About link key
    nav_contact: "Contact",

    // Announcement Top Banner
    banner_tag: "NEW RELEASE",
    banner_text: "FUKKONI Lite is Now Live! Launch your Free Instagram Bio Link & WhatsApp Store in 60s — 100% Free Forever.",
    banner_cta: "Create Free Store",

    // Hero Section
    hero_newFeatures_badge: "New Dashboard Features Available",
    hero_storefront_badge: "🛍️ Launch your Free Online Store for Instagram & WhatsApp (100% Free Forever)",
    hero_title_part1: "The Complete Operating System for",
    hero_title_part2: "Retail, Pharmacy & Hospitality", // Updated Slogan
    hero_description:
      "Streamline operations, boost efficiency, and scale your business with the all-in-one platform built for your specific industry.",
    hero_button_getStarted: "Get Started",
    hero_button_create_store: "Create Free Store Link (Free Forever)",
    hero_button_watchDemo: "Watch Demo",
    hero_trustedBy: "Trusted by",
    hero_businesses: "businesses",
    hero_stats_monthlySales: "Monthly Sales",

    // FUKKONI Lite Showcase
    lite_badge: "NOW AVAILABLE • 100% FREE FOREVER",
    lite_title_part1: "Start Selling Online with",
    lite_description: "No subscription, no POS hardware required. Launch your branded social bio link catalog in 60 seconds and receive instant, clean customer orders directly on WhatsApp.",
    lite_card1_title: "Branded Bio Link Store",
    lite_card1_desc: "Get a sleek, mobile-optimized store link (store.fukkoni.com/your-brand) ready for your Instagram, TikTok, and Facebook bio.",
    lite_card2_title: "Direct WhatsApp Orders",
    lite_card2_desc: "Shoppers select items, colors, and sizes. Orders land directly in your WhatsApp with formatted receipt details and delivery address.",
    lite_card3_title: "Global Currencies & MoMo",
    lite_card3_desc: "Display prices in RWF, USD, EUR, CDF, KES, or any world currency. Accept MoMo USSD, bank transfer, or online payment links.",
    lite_card4_title: "Zero Cost, Zero Risk",
    lite_card4_desc: "No monthly fee, no credit card required. Free forever for boutique owners, creators, and social commerce entrepreneurs.",
    lite_vs_pro_title: "Choose the Perfect Mode for Your Business",
    lite_vs_pro_sub: "Start free on Lite today, upgrade to Pro POS whenever you open a physical storefront.",
    lite_plan_tag: "FREE FOREVER",
    lite_plan_for: "For Social Media Boutiques & Online Sellers",
    lite_feat_1: "Public Branded Bio Link (store.fukkoni.com/your-shop)",
    lite_feat_2: "Unlimited Products, Photos & Category Collections",
    lite_feat_3: "Direct WhatsApp Cart & Instant Order Notifications",
    lite_feat_4: "Multi-Currency Display & MoMo / Bank Transfer Instructions",
    lite_feat_5: "Customer Order Status Tracking & QR Code Sharing",
    lite_cta_btn: "Create Free Store Now",
    pro_plan_for: "For Physical Stores, Supermarkets & High-Volume Retail",
    pro_feat_all_lite: "Everything in FUKKONI Lite",
    pro_feat_1: "High-Speed Cashier POS & Thermal Receipt Printing",
    pro_feat_2: "Stock Restocking, Inventory Tracking & Low Stock Alerts",
    pro_feat_3: "Multi-Staff Accounts & Role-Based Permissions",
    pro_feat_4: "Shift Reconciliation, Tax Compliance & Profit Margin Reports",
    pro_cta_btn: "Start 14-Day Free Pro Trial",

    // Features Section
    features_badge: "Powerful Capabilities",
    features_title_part1: "Everything You Need to",
    features_title_part2: "Run Your Business", // Updated to be more generic than "Store"
    features_description:
      "Powerful features designed to help you grow your business and streamline operations",

    features_inventory_title: "Inventory Management",
    features_inventory_description:
      "Real-time tracking and automated reordering system to prevent stockouts and optimize inventory levels.",

    features_analytics_title: "Advanced Analytics",
    features_analytics_description:
      "Comprehensive reports and business insights that help you make data-driven decisions for growth.",

    features_customer_title: "Customer Management",
    features_customer_description:
      "Track customer behavior and preferences to personalize their shopping experience and boost loyalty.",

    features_integration_title: "Easy Integration",
    features_integration_description:
      "Seamless integration with existing systems including e-commerce platforms, payment gateways, and more.",

    features_updates_title: "Real-time Updates",
    features_updates_description:
      "Instant synchronization across all devices ensuring your team always has the latest information.",

    features_security_title: "Secure Platform",
    features_security_description:
      "Enterprise-grade security for your data with regular backups and advanced encryption protocols.",

    features_button_seePricing: "See our pricing plans",
    features_button_exploreSolutions: "Explore our industry solutions",

    // Solutions Section
    solutions_badge: "Industry Specific Solutions",
    solutions_title_part1: "Tailored Management for",
    solutions_title_part2: "Your Vertical",
    solutions_description: "From healthcare to hospitality, Fukkoni provides specialized modules built for your industry's unique challenges.",

    // Social Commerce vertical
    solution_lite_title: "FUKKONI Lite (Social Commerce)",
    solution_lite_description: "Instant online bio link catalog and direct WhatsApp checkout for modern social sellers.",
    solution_lite_feat1: "Free Bio Link Store (store.fukkoni.com/you)",
    solution_lite_feat2: "Direct WhatsApp Order Receiving",
    solution_lite_feat3: "Zero Fees & Multi-Currency Ready",

    // Pharmacy vertical
    solution_pharmacy_title: "Fukkoni Pharmacy",
    solution_pharmacy_description: "The complete dispensing and inventory solution for modern pharmacies.",
    solution_pharmacy_feat1: "FEFO & Expiry Tracking",
    solution_pharmacy_feat2: "Prescription Management",
    solution_pharmacy_feat3: "Patient Medication History",

    // Bar & Restaurant vertical
    solution_bar_title: "Fukkoni Bar & Counter",
    solution_bar_description: "Dynamic tab and inventory management for high-volume hospitality.",
    solution_bar_feat1: "Pour Cost & Variance",
    solution_bar_feat2: "Open Tab Management",
    solution_bar_feat3: "Shift & Incident Reporting",

    // Retail vertical
    solution_retail_title: "Fukkoni Retail POS",
    solution_retail_description: "High-speed retail management for supermarkets and general stores.",
    solution_retail_feat1: "Multi-Unit Restocking",
    solution_retail_feat2: "Bulk Pricing Management",
    solution_retail_feat3: "Customer Loyalty Programs",

    // Stats Section
    stats_badge: "Our Impact",
    stats_title: "Fukkoni by the Numbers",
    stats_description: "We're empowering businesses across the region with reliable, real-time management technology.",
    stats_shops_label: "Active Shops",
    stats_visitors_label: "Site Visitors",
    stats_transactions_label: "Transactions Tracked",
    stats_countries_label: "Countries Reached",

    // Pricing Section
    pricing_badge: "Flexible Plans For Everyone",
    pricing_title_part1: "Simple, Transparent",
    pricing_title_part2: "Pricing",
    pricing_description:
      "Choose the plan that best fits your business needs with no hidden fees",

    pricing_plan_mostPopular: "Most Popular",
    pricing_plan_month: "month",

    // Plan names (using keys for consistency)
    plan_starter_name: "Starter",
    plan_professional_name: "Professional",
    plan_enterprise_name: "Enterprise",

    // Plan features (using keys)
    feature_products_1k: "Up to 1,000 products",
    feature_products_10k: "Up to 10,000 products",
    feature_products_unlimited: "Unlimited products",

    feature_analytics_basic: "Basic analytics",
    feature_analytics_advanced: "Advanced analytics",
    feature_analytics_custom: "Custom analytics",

    feature_users_2: "2 user accounts",
    feature_users_5: "5 user accounts",
    feature_users_unlimited: "Unlimited users",

    feature_support_email: "Email support",
    feature_support_priority: "Priority support",
    feature_support_24_7: "24/7 support",

    feature_access_mobile: "Mobile app access",
    feature_access_api: "API access",
    feature_integration_custom: "Custom integration",

    feature_reports_custom: "Custom reports",
    feature_account_manager: "Dedicated account manager",

    pricing_customPlan_cta_part1: "Need a custom plan for your enterprise?",
    pricing_customPlan_cta_part2: "Contact us",

    // Contact Section
    contact_badge: "Contact Us",
    contact_title_part1: "Get in",
    contact_title_part2: "Touch",
    contact_description:
      "Have questions or need assistance? Our team is here to help you.",

    contact_form_name_label: "Full Name",
    contact_form_name_placeholder: "John Doe",
    contact_form_email_label: "Email Address",
    contact_form_email_placeholder: "john@example.com",
    contact_form_message_label: "Message",
    contact_form_message_placeholder: "How can we help you?",
    contact_form_button_sending: "Sending...",
    contact_form_button_sendMessage: "Send Message",
    contact_form_success_title: "Message Sent!",
    contact_form_success_message: "We'll get back to you as soon as possible.",

    contact_info_title: "Contact Information",
    contact_info_email_label: "Email",
    contact_info_phone_label: "Phone",
    contact_info_office_label: "Offices", // Changed to plural
    contact_info_email_address: "nankim45@gmail.com",
    contact_info_phone_number: "(250) 782 015 589",
    contact_info_phone_number_2: "+243 970 310 329", // Added 2nd phone
    contact_info_office_address_line1: "Gisimeti",
    contact_info_office_address_line2: "Remera",
    contact_info_office_address_line3: "Kigali, KG 37 B",
    contact_info_office_2_address_line1: "Center Ville", // Added 2nd address
    contact_info_office_2_address_line2: "Goma",
    
    // Footer Section
    footer_brand_description:
      "Transforming business management with innovative solutions. Our platform helps businesses streamline operations and scale efficiently.",
    footer_back_to_top_aria: "Back to top",
    footer_follow_us_aria: "Follow us on",
    footer_title_product: "Product",
    footer_title_company: "Company",
    footer_title_support: "Support",
    footer_link_integration: "Integration",
    footer_link_documentation: "Documentation",
    footer_link_updates: "Updates",
    footer_link_careers: "Careers",
    footer_link_blog: "Blog",
    footer_link_partners: "Partners",
    footer_link_helpCenter: "Help Center",
    footer_link_terms: "Terms of Service",
    footer_link_privacy: "Privacy Policy",
    footer_link_status: "Status",
    footer_link_contactSupport: "Contact Support",
    footer_copyright_allRightsReserved: "All rights reserved.",

    // Navbar ARIA labels
    nav_open_menu_aria: "Open main menu",
    nav_close_menu_aria: "Close main menu",
  },
  // Add other languages (fr, es, rw) with corresponding translations
  fr: {
    // Navigation
    nav_brand: "FUKKONI",
    nav_home: "Accueil",
    nav_features: "Fonctionnalités",
    nav_pricing: "Tarifs",
    nav_about: "À Propos",
    nav_contact: "Contact",

    // Announcement Top Banner
    banner_tag: "NOUVEAUTÉ",
    banner_text: "FUKKONI Lite est Disponible ! Créez votre boutique Bio Link Instagram & WhatsApp en 60s — 100% Gratuit à Vie.",
    banner_cta: "Créer ma Boutique Gratuite",

    // Hero Section
    hero_newFeatures_badge:
      "Nouvelles fonctionnalités disponibles",
    hero_storefront_badge:
      "🛍️ Lancez votre Boutique en Ligne Gratuite pour Instagram & WhatsApp (100% Gratuit à Vie)",
    hero_title_part1: "La Plateforme de Gestion Tout-en-un pour",
    hero_title_part2: "Commerce, Pharmacie & Hôtellerie",
    hero_description:
      "Simplifiez les opérations, augmentez l'efficacité et développez votre activité avec notre plateforme de gestion intelligente conçue pour votre industrie.",
    hero_button_getStarted: "Se Lancer",
    hero_button_create_store: "Créer un Lien Gratuit (Gratuit à Vie)",
    hero_button_watchDemo: "Voir la Démo",
    hero_trustedBy: "Reconnu par",
    hero_businesses: "entreprises",
    hero_stats_monthlySales: "Ventes Mensuelles",

    // FUKKONI Lite Showcase
    lite_badge: "DISPONIBLE DÈS MAINTENANT • 100% GRATUIT À VIE",
    lite_title_part1: "Vendez en ligne facilement avec",
    lite_description: "Sans abonnement ni matériel requis. Lancez votre catalogue bio link en 60 secondes et recevez vos commandes clients directement sur WhatsApp.",
    lite_card1_title: "Boutique Lien Bio Personnalisée",
    lite_card1_desc: "Obtenez un lien de boutique moderne (store.fukkoni.com/votre-marque) optimisé pour votre bio Instagram, TikTok et Facebook.",
    lite_card2_title: "Commandes Directes WhatsApp",
    lite_card2_desc: "Vos clients sélectionnent produits, couleurs et tailles. Les commandes arrivent directement sur votre WhatsApp avec l'adresse de livraison.",
    lite_card3_title: "Multi-Devises & MoMo",
    lite_card3_desc: "Affichez vos prix en RWF, USD, EUR, CDF, KES ou toute autre devise. Acceptez les paiements MoMo USSD et virements bancaires.",
    lite_card4_title: "Zéro Frais, Zéro Risque",
    lite_card4_desc: "Aucun abonnement mensuel, aucune carte bancaire requise. 100% gratuit pour les créateurs et boutiques en ligne.",
    lite_vs_pro_title: "Choisissez la formule idéale pour votre commerce",
    lite_vs_pro_sub: "Démarrez gratuitement sur Lite aujourd'hui, et passez à Pro POS quand vous ouvrez un magasin physique.",
    lite_plan_tag: "GRATUIT À VIE",
    lite_plan_for: "Pour les Boutiques Réseaux Sociaux & Vendeurs en Ligne",
    lite_feat_1: "Lien Bio Public Personnalisé (store.fukkoni.com/votre-boutique)",
    lite_feat_2: "Produits, Photos et Collections Illimités",
    lite_feat_3: "Panier WhatsApp Direct & Alertes Commandes Instantanées",
    lite_feat_4: "Affichage Multi-Devises & Instructions MoMo / Bancaires",
    lite_feat_5: "Suivi des Commandes Clients & Partage par QR Code",
    lite_cta_btn: "Créer ma Boutique Gratuite",
    pro_plan_for: "Pour Magasins Physiques, Supermarchés & Vente à Fort Volume",
    pro_feat_all_lite: "Tout ce qui est inclus dans FUKKONI Lite",
    pro_feat_1: "Caisse Enregistreuse Ultra-Rapide & Impression Tickets Thermiques",
    pro_feat_2: "Gestion des Stocks, Réassort & Alertes Ruptures",
    pro_feat_3: "Comptes Multi-Employés & Permissions par Rôle",
    pro_feat_4: "Clôture de Caisse, Conformité Fiscale & Marges Bénéficiaires",
    pro_cta_btn: "Essai Gratuit Pro 14 Jours",

    // Features Section
    features_badge: "Fonctionnalités Puissantes",
    features_title_part1: "Tout ce dont vous avez besoin pour",
    features_title_part2: "Gérer Votre Activité",
    features_description:
      "Des outils puissants conçus pour vous aider à développer votre chiffre d'affaires et à rationaliser vos opérations.",

    features_inventory_title: "Gestion des Stocks",
    features_inventory_description:
      "Suivi en temps réel et réapprovisionnement automatisé pour éviter les ruptures et optimiser la trésorerie.",

    features_analytics_title: "Analyses Avancées",
    features_analytics_description:
      "Rapports détaillés et insights stratégiques pour prendre des décisions basées sur les données.",

    features_customer_title: "Gestion Client (CRM)",
    features_customer_description:
      "Analysez le comportement d'achat pour personnaliser l'expérience client et renforcer la fidélité.",

    features_integration_title: "Intégration Fluide",
    features_integration_description:
      "Connectez-vous facilement à vos outils existants : e-commerce, terminaux de paiement, et plus encore.",

    features_updates_title: "Temps Réel",
    features_updates_description:
      "Synchronisation instantanée sur tous vos appareils. Votre équipe dispose toujours de l'information à jour.",

    features_security_title: "Sécurité Maximale",
    features_security_description:
      "Protection de niveau entreprise avec sauvegardes automatiques et chiffrement avancé de vos données.",

    features_button_seePricing: "Voir les tarifs",
    features_button_exploreSolutions: "Découvrir nos solutions",

    // Solutions Section
    solutions_badge: "Solutions par Industrie",
    solutions_title_part1: "Une Gestion Adaptée à",
    solutions_title_part2: "Votre Métier",
    solutions_description: "De la santé à la restauration, Fukkoni propose des modules spécialisés répondant aux défis uniques de votre secteur.",

    // Social Commerce vertical
    solution_lite_title: "FUKKONI Lite (Commerce Social)",
    solution_lite_description: "Catalogue en ligne instantané et prise de commandes WhatsApp pour boutiques modernes.",
    solution_lite_feat1: "Boutique Lien Bio Gratuite (store.fukkoni.com/vous)",
    solution_lite_feat2: "Réception Directe des Commandes WhatsApp",
    solution_lite_feat3: "Zéro Frais & Compatible Multi-Devises",

    // Pharmacy vertical
    solution_pharmacy_title: "Fukkoni Pharmacie",
    solution_pharmacy_description: "La solution complète de dispensation et d'inventaire pour les pharmacies modernes.",
    solution_pharmacy_feat1: "Suivi FEFO & Expiration",
    solution_pharmacy_feat2: "Gestion des Ordonnances",
    solution_pharmacy_feat3: "Dossier Médical Patient",

    // Bar & Restaurant vertical
    solution_bar_title: "Fukkoni Bar & Resto",
    solution_bar_description: "Gestion dynamique des commandes et des stocks pour les établissements à fort volume.",
    solution_bar_feat1: "Contrôle des Dosages (Pour Cost)",
    solution_bar_feat2: "Gestion des Ardoises",
    solution_bar_feat3: "Rapports de Service & Incidents",

    // Retail vertical
    solution_retail_title: "Fukkoni Commerce",
    solution_retail_description: "Caisse ultra-rapide et gestion pour supermarchés et boutiques.",
    solution_retail_feat1: "Réassort Multi-Points",
    solution_retail_feat2: "Gestion Prix de Gros",
    solution_retail_feat3: "Programmes de Fidélité",

    // Stats Section
    stats_badge: "Notre Impact",
    stats_title: "Fukkoni en Chiffres",
    stats_description: "Nous propulsons les entreprises de la région avec une technologie fiable et temps réel.",
    stats_shops_label: "Commerces Actifs",
    stats_visitors_label: "Visiteurs Uniques",
    stats_transactions_label: "Transactions Traitées",
    stats_countries_label: "Pays Présents",

    // Pricing Section
    pricing_badge: "Offres Flexibles",
    pricing_title_part1: "Tarification Simple et",
    pricing_title_part2: "Transparente",
    pricing_description:
      "Choisissez le plan adapté à vos besoins, sans frais cachés.",

    pricing_plan_mostPopular: "Le Plus Populaire",
    pricing_plan_month: "mois",

    // Plan names
    plan_starter_name: "Démarrage",
    plan_professional_name: "Professionnel",
    plan_enterprise_name: "Entreprise",

    // Plan features
    feature_products_1k: "Jusqu'à 1 000 produits",
    feature_products_10k: "Jusqu'à 10 000 produits",
    feature_products_unlimited: "Produits illimités",

    feature_analytics_basic: "Analyses essentielles",
    feature_analytics_advanced: "Analyses avancées",
    feature_analytics_custom: "Analyses sur mesure",

    feature_users_2: "2 utilisateurs",
    feature_users_5: "5 utilisateurs",
    feature_users_unlimited: "Utilisateurs illimités",

    feature_support_email: "Support par email",
    feature_support_priority: "Support prioritaire",
    feature_support_24_7: "Support dédié 24/7",

    feature_access_mobile: "Application mobile",
    feature_access_api: "Accès API",
    feature_integration_custom: "Intégration sur mesure",

    feature_reports_custom: "Rapports personnalisés",
    feature_account_manager: "Chargé de compte dédié",

    pricing_customPlan_cta_part1:
      "Besoin d'une offre pour votre grande entreprise ?",
    pricing_customPlan_cta_part2: "Contactez-nous",

    // Contact Section
    contact_badge: "Contactez-nous",
    contact_title_part1: "Prenez",
    contact_title_part2: "Contact",
    contact_description:
      "Une question ? Un projet ? Notre équipe est à votre écoute.",

    contact_form_name_label: "Nom Complet",
    contact_form_name_placeholder: "Jean Dupont",
    contact_form_email_label: "Adresse Email",
    contact_form_email_placeholder: "jean@exemple.com",
    contact_form_message_label: "Message",
    contact_form_message_placeholder: "Comment pouvons-nous vous aider ?",
    contact_form_button_sending: "Envoi en cours...",
    contact_form_button_sendMessage: "Envoyer le Message",
    contact_form_success_title: "Message Envoyé !",
    contact_form_success_message: "Nous reviendrons vers vous très rapidement.",

    contact_info_title: "Coordonnées",
    contact_info_email_label: "Email",
    contact_info_phone_label: "Téléphone",
    contact_info_office_label: "Bureaux",
    contact_info_email_address: "nankim45@gmail.com",
    contact_info_phone_number: "(250) 782 015 589",
    contact_info_phone_number_2: "+243 970 310 329", // Added 2nd phone (Already in file, confirming it stays)
    contact_info_office_address_line1: "Gisimeti",
    contact_info_office_address_line2: "Remera",
    contact_info_office_address_line3: "Kigali, KG 37 B",
    contact_info_office_2_address_line1: "Centre Ville", // Corrected spelling Center -> Centre
    contact_info_office_2_address_line2: "Goma",
    
    // Footer Section
    footer_brand_description:
      "Transformez la gestion de votre commerce avec des solutions innovantes. Notre plateforme aide les entreprises à optimiser leurs opérations et à croître efficacement.",
    footer_back_to_top_aria: "Retour en haut de page",
    footer_follow_us_aria: "Suivez-nous sur",
    footer_title_product: "Produit",
    footer_title_company: "Entreprise",
    footer_title_support: "Support",
    footer_link_integration: "Intégration",
    footer_link_documentation: "Documentation",
    footer_link_updates: "Mises à Jour",
    footer_link_careers: "Carrières",
    footer_link_blog: "Blog",
    footer_link_partners: "Partenaires",
    footer_link_helpCenter: "Centre d'Aide",
    footer_link_terms: "Conditions d'Utilisation",
    footer_link_privacy: "Politique de Confidentialité",
    footer_link_status: "Statut",
    footer_link_contactSupport: "Contacter le Support",
    footer_copyright_allRightsReserved: "Tous droits réservés.",

    // Navbar ARIA labels
    nav_open_menu_aria: "Ouvrir le menu principal",
    nav_close_menu_aria: "Fermer le menu principal",
  },
  // ... add es and rw translations following the same structure
};

export default translations;
